/**
 * 사원 직종 — 폴백 상수
 *
 * ★ 실제 운영 목록은 DB `caion_job_type` (관리자 > 직종관리, 권한 80).
 * 프론트는 `useJobTypes()` / `employeeApi.getJobTypes()` 로 조회한다.
 * 아래 배열은 API 실패·초기 렌더 시에만 사용.
 */
export const EMPLOYEE_POSITION_OPTIONS = [
  '요양보호사',
  '사회복지사',
  '센터장',
  '시설장(관리책임자)',
  '간호사',
  '간호조무사',
  '물리치료사',
  '작업치료사',
  '위생원',
  '조리사',
  '조리원',
  '사무원',
  '운전원',
  '기타',
] as const;

export type EmployeePositionOption = (typeof EMPLOYEE_POSITION_OPTIONS)[number];

/** @deprecated useJobTypes().isEmployeePosition 권장 */
export function isEmployeePosition(value: string | null | undefined): boolean {
  if (!value) return false;
  return (EMPLOYEE_POSITION_OPTIONS as readonly string[]).includes(value);
}

/** 생산직 비과세 폴백 — DB cjt_is_production 이 우선 */
export const PRODUCTION_WORKER_POSITION_KEYWORDS = ['요양보호사', '조리사', '조리원'] as const;
